import {TestType} from '@esgi/contracts/esgi/types/esgi.enums/test-type';

export const testTypeMap = Object.keys(TestType).reduce((result, key) => {
	result[key] = TestType[key];
	return result;
}, {});
